
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "version": "1.1",
    "id": "图层_1",
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "x": "0px",
    "y": "0px",
    "width": "17px",
    "height": "17px",
    "viewBox": "0 0 17 17",
    "enable-background": "new 0 0 17 17",
    "xml:space": "preserve"
  },
  "children": [
    {
      "tag": "g",
      "attrsMap": {
        "id": "配置",
        "transform": "translate(-1086 -664)"
      },
      "children": [
        {
          "tag": "g",
          "attrsMap": {
            "id": "配置-2",
            "transform": "translate(960 579.668)"
          },
          "children": [
            {
              "tag": "path",
              "attrsMap": {
                "id": "路径_7",
                "fill": "#FFFFFF",
                "d": "M134.751,100.332c-0.096,0-0.191-0.025-0.275-0.072l-6.188-3.47\n\t\t\tC128.11,96.691,128,96.504,128,96.3v-6.937c0-0.204,0.109-0.392,0.287-0.491l6.188-3.468c0.171-0.096,0.379-0.096,0.55,0\n\t\t\tl6.188,3.468c0.178,0.1,0.287,0.288,0.287,0.491V96.3c0,0.204-0.109,0.392-0.287,0.491l-6.188,3.468\n\t\t\tC134.941,100.307,134.847,100.332,134.751,100.332z M129.126,95.971l5.625,3.149l5.625-3.153v-6.276l-5.625-3.153l-5.625,3.153\n\t\t\tV95.971z"
              }
            },
            {
              "tag": "path",
              "attrsMap": {
                "id": "路径_8",
                "fill": "#FFFFFF",
                "d": "M134.751,95.631c-1.546,0-2.8-1.254-2.8-2.8c0-1.546,1.253-2.8,2.8-2.8\n\t\t\tc1.546,0,2.8,1.253,2.8,2.8l0,0C137.551,94.377,136.297,95.631,134.751,95.631z M134.751,91.081c-0.966,0-1.75,0.783-1.75,1.75\n\t\t\tc0,0.966,0.784,1.75,1.75,1.75c0.966,0,1.75-0.784,1.75-1.75C136.501,91.864,135.717,91.081,134.751,91.081z"
              }
            }
          ]
        }
      ]
    }
  ]
})
    }
  